export const CURRENCIES = {
  USD: 'USD',
  EUR: 'EUR',
} as const;
